import { css } from '@emotion/react';
import breakpoints from './breakpoints';

type CssObject = Record<string, any>;

export function getContainerQueriesStyles(className: string, objectCss: CssObject): string {
  const containersDirectives: CssObject = {};
  Object.entries(objectCss).forEach(([key, value]) => {
    if (key.startsWith('@container')) {
      containersDirectives[key] = value;
    }
  });

  const styles = Object.entries(containersDirectives)
    .map(([key, value]) => `${key} { ${className} { ${css(value).styles} } }`)
    .join('');

  return styles;
}

function getCssValue(value: string | number): string {
  const val = breakpoints.values[value] ?? value;
  return typeof val === 'number' ? `${val}px` : val;
}

const getName = (name: string): string => (name ? `${name} ` : '');

const up = (value: string | number, name = ''): string =>
  `@container ${getName(name)}(min-width: ${getCssValue(value)})`;

const down = (value: string | number, name = ''): string =>
  `@container ${getName(name)}(max-width: ${getCssValue(value)})`;

const between = (min: string | number, max: string | number, name = ''): string =>
  `@container ${getName(name)}(min-width: ${getCssValue(min)}) and (max-width: ${getCssValue(
    max
  )})`;

const only = (value: string | number, name = ''): string =>
  `@container ${getName(name)}(min-width: ${getCssValue(value)}) and (max-width: ${getCssValue(
    value
  )})`;

function containerQueries(containerName?: string) {
  /* istanbul ignore next */

  return {
    up: (value: string | number) => up(value, containerName),
    down: (value: string | number) => down(value, containerName),
    between: (min: string | number, max: string | number) => between(min, max, containerName),
    only: (value: string | number) => only(value, containerName),
  };
}

containerQueries.up = up;
containerQueries.down = down;
containerQueries.between = between;
containerQueries.only = only;

export default containerQueries;
